export default __webpack_public_path__ + "static/studionft-2-0e22989bc90be8b512e9d6c5680cde1f.mp4";